/* filepath: /Users/imrannomanipersional/m247digitalsignagev3/src/components/shared/PoweredBy.tsx */
import React from "react";
import "./PoweredBy.css";

interface PoweredByProps {
  className?: string;
  showUrl?: boolean;
}

const PoweredBy: React.FC<PoweredByProps> = ({
  className = "",
  showUrl = false,
}) => {
  return (
    <div className={`powered-by-footer ${className}`}>
      <span className="powered-by">Powered by </span>
      <span className="masjid-brand"> Masjid 24/7 </span>
    </div>
  );
};

export default PoweredBy;
